/**
 * Timeout Interceptor.
 */

module.exports = function () {

    var timeout;

    return {

        request: function (request) {

            if (request.timeout) {
                timeout = setTimeout(function () {
                    request.cancel();
                }, request.timeout);
            }

            return request;
        },

        response: function (response) {

            clearTimeout(timeout);

            return response;
        }

    };
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-resource/src/http/timeout.js
 ** module id = 98
 ** module chunks = 0
 **/